"use client";

import { useEffect, useRef, type ReactNode } from "react";
import { MessageBubble, type ChatMessage } from "./MessageBubble";
import { ActionMessage } from "./ActionMessage";
import { TypingIndicator } from "./TypingIndicator";

export function MessageList({
  messages,
  isWaiting,
  sessionId,
  emptyState,
}: {
  messages: ChatMessage[];
  isWaiting: boolean;
  sessionId: string | null;
  emptyState?: ReactNode;
}) {
  const endRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth", block: "end" });
  }, [messages, isWaiting]);

  if (messages.length === 0 && !isWaiting && emptyState) {
    return <div className="h-full">{emptyState}</div>;
  }

  return (
    <ol
      role="log"
      aria-label="Chat history"
      className="flex flex-col gap-3 overflow-y-auto px-3 py-3"
    >
      {messages.map((m) => (
        <li key={m.id}>
          {m.role === "user" ? (
            <MessageBubble message={m} />
          ) : (
            <ActionMessage text={m.text} sessionId={sessionId} />
          )}
        </li>
      ))}
      {isWaiting && (
        <li>
          <TypingIndicator />
        </li>
      )}
      <div ref={endRef} />
    </ol>
  );
}
